import { gqlNetworkFetch } from '@bts-web/utils-relay';
import {
  ExternalCryptoAddressesQuery,
  ExternalCryptoAddressesQuery$data,
  ExternalCryptoAddressesQueryNode,
  ListExternalCryptoAddressesInput,
} from '@bts-web/data-layer/server';

interface CryptoAddressesResponse {
  data: ExternalCryptoAddressesQuery$data;
  errors?: string[];
}

export const getExternalCryptoAddresses = async (
  input: ListExternalCryptoAddressesInput,
): Promise<CryptoAddressesResponse> => {
  const response = await gqlNetworkFetch<ExternalCryptoAddressesQuery>(
    ExternalCryptoAddressesQueryNode.params,
    {
      input,
    },
  );

  return response;
};
